import "react";
function n(o, e) {
  return o.defaultProps = e, o;
}
function t() {
  let o;
  if (typeof self < "u" && (o = self), typeof window < "u" && (o = window), typeof global < "u" && (o = global), typeof globalThis < "u" && (o = globalThis), o)
    return o;
  throw new Error("unable to locate global object");
}
const f = () => t().window.innerWidth - t().document.body.offsetWidth;
export {
  f as b,
  t as g,
  n as w
};
//# sourceMappingURL=useIntersectionObserver-1ee6520e.mjs.map
